import { Stack, Tooltip, Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { ListChecks } from 'lucide-react'
import { FormattedMessage } from 'react-intl'
import { TaskTypeStyles } from './styles'

export const ReviewTaskComponent: React.FC = () => (
    <Stack direction="row" spacing={1} alignItems="center">
        <C1Icon icon={ListChecks} sx={TaskTypeStyles.reviewIcon} size="sm" />
        <Typography>
            <FormattedMessage id="task_type_review" defaultMessage="Review" />
        </Typography>
    </Stack>
)

export const ReviewTaskIcon: React.FC = () => (
    <Tooltip title={<FormattedMessage id="task_type_review" defaultMessage="Review" />} placement="top">
        <C1Icon icon={ListChecks} sx={TaskTypeStyles.reviewIcon} size="sm" />
    </Tooltip>
)
